import React from 'react';
import { Page } from '../Page';
export function PageOutro2() {
  return <Page hideFooter variant="dark" data-id="element-1343">
      <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-1344">
        {/* Photo - separate from card, narrower */}
        <div className="w-[525px] h-[300px] mb-4 overflow-hidden" data-id="element-1345">
          <img src="https://cdn.magicpatterns.com/uploads/7FbupA4igV3MjRPDFBJYCQ/5.png" alt="Jack Achenbach" className="w-full h-full object-cover object-[50%_20%]" data-id="element-1346" />
        </div>

        {/* Card */}
        <div className="bg-[#F5F5F0] w-[620px] px-14 py-10 flex flex-col items-center text-center" data-id="element-1347">
          {/* Title */}
          <h1 className="text-4xl font-serif text-[#1F1F1F] leading-snug mb-8" data-id="element-1348">
            Afterword
          </h1>

          {/* Body Text */}
          <div className="space-y-4 text-[11px] text-[#3B3B3B] leading-[1.8] max-w-[440px]" data-id="element-1349">
            <p data-id="element-1350">If you've made it this far, you already have what you need.</p>
            <p data-id="element-1351">
              For many people, seeing the scale finally move is exciting. A lot
              of people have tried for years with diet and exercise alone, so
              seeing progress happen with the help of medication feels like a
              turning point. But this is also where people start to drift.
            </p>
            <p data-id="element-1352">
              The medication helps you eat less, but that's not the full
              picture. The essentials, what you eat, how you move, and the
              habits you build alongside your medication, are what determine not
              just how much weight you lose, but how you feel, how you look, and
              whether you keep the results long term.
            </p>
            <p data-id="element-1353">
              The medication is a tool to get you to a new starting point. The
              structure is what determines where you go from there. Keep it
              simple. Come back to the essentials. Stay consistent with what
              works.
            </p>
            <p data-id="element-1354">
              And most importantly, remember your why. Whether it's your health,
              your family, or your future, that's what carries this forward long
              after the medication ends.
            </p>
          </div>

          {/* Closing Sign-off */}
          <div className="mt-8" data-id="element-1355">
            <p className="font-serif italic text-lg text-[#1F1F1F]" data-id="element-1356">
              Jack Achenbach
            </p>
            <p className="text-[9px] text-[#7A7A70] uppercase tracking-[0.2em] mt-1" data-id="element-1357">
              MS, RDN, CPT
            </p>
          </div>
        </div>
      </div>
    </Page>;
}